import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {User} from '../../../../../auth/models';

@Component({
    selector: 'jft-tender-bids-search-bar',
    templateUrl: './tender-bids-search-bar.component.html',
    styleUrls: ['./tender-bids-search-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderBidsSearchBarComponent implements OnInit {

    public term: string;

    @Output()
    private onChanges = new EventEmitter();

    constructor(
        public user: User,
    ) {
    }

    public ngOnInit() {
    }

    public search() {
        this.onChanges.next(this.term);
    }

    public clearTerm() {
        delete this.term;
        this.onChanges.next(this.term);
    }
}
